// extracted by css-extract-rspack-plugin
export default {"message-container":"marketingObjectiveMessages_message-container__ZSXId","messageContainer":"marketingObjectiveMessages_message-container__ZSXId"};